import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface TerminalTab {
  id:   string
  cwd:  string
  name: string
}

export const useTerminalStore = defineStore('terminal', () => {
  const tabs      = ref<TerminalTab[]>([])
  const activeTab = ref<string | null>(null)
  const isOpen    = ref(false)

  function openTerminal(cwd: string): void {
    const id   = crypto.randomUUID()
    const name = `Terminal ${tabs.value.length + 1}`
    tabs.value.push({ id, cwd, name })
    activeTab.value = id
    isOpen.value    = true
  }

  function closeTab(id: string): void {
    const idx = tabs.value.findIndex(t => t.id === id)
    if (idx === -1) return
    tabs.value.splice(idx, 1)
    if (activeTab.value === id) {
      activeTab.value = tabs.value[idx]?.id ?? tabs.value[idx - 1]?.id ?? null
    }
    if (tabs.value.length === 0) isOpen.value = false
  }

  function togglePanel(): void {
    isOpen.value = !isOpen.value
  }

  return { tabs, activeTab, isOpen, openTerminal, closeTab, togglePanel }
})
